export default __webpack_public_path__ + "static/media/about-us-cesty.dd9d1949.png";